// Helper function returns a promise that resolves after all other promise mocks,
// even if they are chained like Promise.resolve().then(...)
// Technically: this is designed to resolve on the next macrotask

export function tick() {
    return new Promise(resolve => {
        setTimeout(resolve, 0);
    });
}
